import { render, staticRenderFns } from "./GroupInvoiceList.vue?vue&type=template&id=76b1315f"
import script from "./GroupInvoiceList.vue?vue&type=script&lang=js"
export * from "./GroupInvoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports